<template>
  <div class="document-form">
    <housemaid-document-form
      v-if="productId == 12"
      ref="housemaid-document-form"
      :form="form" />
    <decoration-document-form
      v-else-if="productId == 15"
      ref="decoration-document-form"
      :form="form" />
    <travel-document-form
      v-else-if="productId == 14"
      ref="travel-document-form"
      :form="form" />
    <homefire-document-form
      v-else-if="productId == 17||productId == 20"
      ref="homefire-document-form"
      :form="form" />
    <student-document-form
      v-else-if="productId == 16"
      ref="student-document-form"
      :form="form" />
    <working-document-form
      v-else-if="productId == 13"
      ref="working-document-form"
      :form="form" />
    <personal-document-form
      v-else-if="productId == 18"
      ref="personal-document-form"
      :form="form" />
    <template v-else>
      <el-form
        ref="form"
        :rules="rules"
        :disabled="disabled"
        :model="formData">
        <div
          v-if="editTypes==3"
          class="form-item">
          <span >Renewal Letter（Insurer）</span>
          <el-form-item
            ref="renewal_letter_insurer_path_id"
            prop="renewal_letter_insurer_path_id">
            <file-container
              :edit="true"
              :fileData="formData.renewal_letter_insurer"
              is-renew-insurer
              :otherData="{
                target: 'renewal_letter_insurer',
                idKey: 'renewal_letter_insurer_path_id',
                nameKey: 'renewal_letter_insurer_path',
                type:'renewal_letter_insurer_path'
              }"
              titleName="Renewal Letter（Insurer）"
              :copyNcd.sync="copy_ncd"
              @delete="handlerDeleteFile"
              @uploadSuccess="handlerUploadSuccess" />
          </el-form-item>
        </div>
        <div class="form-item">
          <span  v-if="form.cust_typ == 2">Certificate of Incorporation/Business Registration Certificate</span>
          <span v-else>Policyholder HKID</span>
          <el-form-item
            ref="id_type_pic_path_id"
            :prop="editTypes!==1?'id_type_pic_path_id':''">
            <file-container
              :edit="true"
              :fileData="formData.id_type_pic"
              :file-list="fileList"
              :otherData="{
                target: 'id_type_pic',
                idKey: 'id_type_pic_path_id',
                nameKey: 'id_type_pic_path',
                type:'id_type_pic_path'
              }"
              :titleName="form.cust_typ == 2? 'Certificate of Incorporation/Business Registration Certificate' : 'Policyholder HKID'"
              @delete="handlerDeleteFile"
              @uploadSuccess="handlerUploadSuccess" />
          </el-form-item>
        </div>
        <template v-if="!isMotorTrade">
          <div class="form-item">
            <span>NCD proof (e.g. Renewal Notice)</span>
            <el-form-item
              ref="ncd_proof_path_id"
              :prop="editTypes===2?'ncd_proof_path_id':''">
              <file-container
                :edit="true"
                :fileData="formData.ncd_proof"
                :file-list="fileList"
                :otherData="{
                  target: 'ncd_proof',
                  idKey: 'ncd_proof_path_id',
                  type:'ncd_proof_path',
                  nameKey: 'ncd_proof_path'
                }"
                titleName= "NCD proof (e.g. Renewal Notice)"
                @delete="handlerDeleteFile"
                @uploadSuccess="handlerUploadSuccess" />
            </el-form-item>
          </div>
          <div
            class="form-item">
            <span>Vehicle Registration Document</span>
            <el-form-item
              ref="rgtn_pic_path_id"
              prop="rgtn_pic_path_id">
              <file-container
                :edit="true"
                :fileData="formData.rgtn_pic"
                :file-list="fileList"
                :otherData="{
                  target: 'rgtn_pic',
                  type:'rgtn_pic_path',
                  idKey: 'rgtn_pic_path_id',
                  nameKey: 'rgtn_pic_path'
                }"
                titleName= "Vehicle Registration Document"
                @delete="handlerDeleteFile"
                @uploadSuccess="handlerUploadSuccess" />
            </el-form-item>
          </div>
          <div
            class="form-item">
            <span>Vehicle Registration Document with previous owner name / Vehicle Document</span>
            <el-form-item
              ref="rgtn_with_owner_pic_path_id"
              prop="rgtn_with_owner_pic_path_id">
              <file-container
                :edit="true"
                :fileData="formData.rgtn_with_owner_pic"
                :file-list="fileList"
                :otherData="{
                  target: 'rgtn_with_owner_pic',
                  idKey: 'rgtn_with_owner_pic_path_id',
                  nameKey: 'rgtn_with_owner_pic_path',
                  type:'rgtn_with_owner_pic_path'
                }"
                titleName= "Vehicle Registration Document with previous owner name / Vehicle Document"
                @delete="handlerDeleteFile"
                @uploadSuccess="handlerUploadSuccess" />
            </el-form-item>
          </div>
        </template>
        <!--        <div-->
        <!--          v-if="form.cust_typ == 2"-->
        <!--          class="form-item">-->
        <!--          <span>Business Registration Certificate</span>-->
        <!--          <el-form-item-->
        <!--            ref="br_pic_path_id"-->
        <!--            prop="br_pic_path_id"-->
        <!--          >-->
        <!--            <file-container-->
        <!--              :edit="true"-->
        <!--              :fileData="formData.br_pic"-->
        <!--              :otherData="{-->
        <!--                target: 'br_pic',-->
        <!--                idKey: 'br_pic_path_id',-->
        <!--                nameKey: 'br_pic_path'-->
        <!--              }"-->
        <!--              titleName= "Business Registration Certificate"-->
        <!--              @delete="handlerDeleteFile"-->
        <!--              @uploadSuccess="handlerUploadSuccess" />-->
        <!--          </el-form-item>-->
        <!--        </div>-->
        <template v-if="!isMotorTrade||isMotorTrade&&!isTPlate">
          <h3>Insured Driver(s)</h3>
          <div
            v-for="(item, index) in driversFileList"
            v-show="!('open' in item) || item.open"
            :key="index"
            class="card">
            <span class="label">{{ item.nm_drvr_lst_nm }} {{ item.nm_drvr_fst_nm }}</span>
            <span class="label">HKID Card</span>
            <file-container
              :edit="true"
              :fileData="{
                url: item.nm_drvr_id_type_pic_url,
                client_name: item.nm_drvr_id_type_pic_name
              }"
              :otherData="{
                index,
                type: 'driver',
                idKey: 'nm_drvr_id_type_pic_path_id',
                nameKey: 'nm_drvr_id_type_pic_path',
                urlKey: 'nm_drvr_id_type_pic_url',
                clientNameKey: 'nm_drvr_id_type_pic_name',
                type:'nm_drvr_id_type_pic',
              }"
              titleName= "HKID Card"
              @delete="handlerDeleteFile"
              @uploadSuccess="handlerUploadSuccess"
            />
            <span class="label">Driving License</span>
            <file-container
              :edit="true"
              :fileData="{
                url: item.nm_drvr_licence_pic_url,
                client_name: item.nm_drvr_licence_pic_name
              }"
              :otherData="{
                index,
                type: 'driver',
                idKey: 'nm_drvr_licence_pic_path_id',
                nameKey: 'nm_drvr_licence_pic_path',
                urlKey: 'nm_drvr_licence_pic_url',
                clientNameKey: 'nm_drvr_licence_pic_name',
                type:'nm_drvr_licence_pic'
              }"
              titleName= "Driving License"
              @delete="handlerDeleteFile"
              @uploadSuccess="handlerUploadSuccess"
            />
          </div>
        </template>
        <h3>Additional Documents</h3>
        <div
          v-for="(item, index) in formData.other_file"
          :key="index + 'other'"
          class="form-item">
          <span>Other File</span>
          <file-container
            :fileData="item"
            :edit="true"
            :file-list="fileList"
            :otherData="{
              index,
              target: 'other_file',
              type:'other_file'
            }"
            titleName= "Additional Documents"
            @delete="handlerDeleteFile"
            @uploadSuccess="handlerUploadSuccess" />
        </div>
        <v-upload
          :file-list="fileList"
          :otherData="{
            type: 'other_file',
            target: 'other_file'
          }"
          @uploadSuccess="handlerUploadSuccess" />
        <template v-if="inter">
          <h3 class="mg-t-15">Internal Documents</h3>
          <div
            v-for="(item, index) in formData.inter_file"
            :key="index + 'inter'"
            class="form-item">
            <file-container
              :fileData="item"
              :edit="true"
              :file-list="fileList"
              :otherData="{
                index,
                target: 'inter_file',
                type:'inter_file'
              }"
              titleName= "Internal Documents"
              @delete="handlerDeleteFile"
              @uploadSuccess="handlerUploadSuccess" />
          </div>
          <v-upload
            :file-list="fileList"
            :otherData="{
              type: 'inter_file',
              target: 'inter_file'
            }"
            @uploadSuccess="handlerUploadSuccess" />
        </template>

      </el-form>
    </template>
  </div>
</template>
<script>
import FileContainer from '@/views/components/file-container'
import DecorationDocumentForm from '@/views/components/modules/decoration/decoration-document-form'
import HousemaidDocumentForm from '@/views/components/modules/housemaid/housemaid-document-form'
import HomefireDocumentForm from '@/views/components/modules/homefire/homefire-document-form'
import TravelDocumentForm from '@/views/components/modules/travel/travel-document-form'
import StudentDocumentForm from '@/views/components/modules/student/student-document-form'
import WorkingDocumentForm from '@/views/components/modules/working/working-document-form'
import personalDocumentForm from '@/views/components/modules/working/working-document-form'
import MixinSelectReminderDoc from '@/mixins/select-reminder-doc'
import {mapState} from 'vuex'
import MixinRules from '@/mixins/rules'

export default {
  name: 'DocumentForm',
  components: {
    FileContainer,
    DecorationDocumentForm,
    HousemaidDocumentForm,
    HomefireDocumentForm,
    TravelDocumentForm,
    StudentDocumentForm,
    WorkingDocumentForm,
    personalDocumentForm,
  },
  mixins: [MixinRules],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    inter: {
      type: Boolean,
      default: false  //  控制是否顯示内部文件
    },
    formDataLock: {
      type: Number,
      default: 0
    },
    editTypes:{
      type: Number,
      default: 0
    },
    currentDriversData: {
      type: Array,
      default: () => ([])
    },
    disabled: {
      type: Boolean,
      default: false
    },
    fileList:{
      type: [Array,Object],
      default: ()=>[]
    },
    isReminder:{
      type: Boolean,
      default: false
    },
  },
  data() {
    const checkNcdProof = (rule, value, callback) => {
      const { ncd_pct } = this.form
      if(!value && ncd_pct != 0) {
        callback(new Error(this.$t('placeholder.upload')))
      }
      callback()
    }
    return {
      oldFormDataLock: -1,
      copy_ncd:false,
      formData: {
        id_type_pic: {},
        ncd_proof: {},
        rgtn_pic: {},
        rgtn_with_owner_pic: {},
        // nm_drvr_list: [],
        other_file: [],
        inter_file: [],
        id_type_pic_path_id: '',
        id_type_pic_path: '',
        rgtn_pic_path_id: '',
        rgtn_pic_path: '',
        rgtn_with_owner_pic_path_id: '',
        rgtn_with_owner_pic_path: '',
        ncd_proof_path_id: '',
        ncd_proof_path: '',
        renewal_letter_insurer_path: '',
        renewal_letter_insurer_path_id: '',
        renewal_letter_insurer: {},
        br_pic:{},
        br_pic_path_id: '',
        br_pic_path: ''
      },
      extraRules: {
        ncd_proof_path_id: [
          // { validator: checkNcdProof, trigger: ['change', 'blur'] }
        ]
      },
      driversFileList: []
    }
  },
  computed: {
    ...mapState('common', ['productId']),
    classId(){
      let {class_id} = this.form||{}
      return class_id
    },
    isMotorTrade(){
      return this.classId==13
    },
    isTPlate(){
      let {type_of_ins} = this.form||{}
      return type_of_ins ==1
    }
    // driversFileList() {
    //   let nm_drvr_list = this.formData.nm_drvr_list
    //   return nm_drvr_list.reduce((result, item) => {
    //     if(!item) {
    //       result.push({})
    //     }
    //     else {
    //       result.push({
    //         idType: {
    //           url: item.nm_drvr_id_type_pic_url,
    //           thumb_url: item.nm_drvr_id_type_pic_thumb_url,
    //           id: item.nm_drvr_id_type_pic_path_id,
    //           path: item.nm_drvr_id_type_pic_path
    //         },
    //         license: {
    //           url: item.nm_drvr_licence_pic_url,
    //           thumb_url: item.nm_drvr_licence_pic_thumb_url,
    //           id: item.nm_drvr_licence_pic_path_id,
    //           path: item.nm_drvr_licence_pic_path
    //         }
    //       })
    //     }
    //     return result
    //   }, [])
    // }
  },
  watch: {
    // 表單鎖，外層會更新，數值變化了才可以更新 formData
    formDataLock: {
      handler(val, old = -1) {
        if(val !== old) {
          this.oldFormDataLock = old
        }
      }
    },
    form: {
      immediate: true,
      deep: true,
      handler(val) {
        if(JSON.stringify(val) != '{}' && this.formDataLock !== this.oldFormDataLock) {
          // 觸發更新就賦值，避免二次更新
          this.oldFormDataLock = this.formDataLock
          Object.keys(this.formData).some(key => {
            if(key in val) {
              this.formData[key] = JSON.parse(JSON.stringify(val[key]))
            }
          })
          this.handler().handlerBackFillData(val)
        }
      }
    },
    currentDriversData: {
      immediate: true,
      deep: true,
      handler(list) {
        const oldList = JSON.parse(JSON.stringify(this.driversFileList))
        this.driversFileList = list.reduce((result, item, index) => {
          const {
            nm_drvr_id_type_pic_url,
            nm_drvr_id_type_pic_thumb_url,
            nm_drvr_id_type_pic_path_id,
            nm_drvr_id_type_pic_path,
            nm_drvr_licence_pic_url,
            nm_drvr_licence_pic_thumb_url,
            nm_drvr_licence_pic_path_id,
            nm_drvr_licence_pic_path
          } = oldList[index] || {}
          let params = { ...item }
          if(oldList[index] && nm_drvr_id_type_pic_path_id) {
            params = {
              ...params,
              nm_drvr_id_type_pic_url,
              nm_drvr_id_type_pic_thumb_url,
              nm_drvr_id_type_pic_path_id,
              nm_drvr_id_type_pic_path
            }
          }
          if(oldList[index] && nm_drvr_licence_pic_path_id) {
            params = {
              ...params,
              nm_drvr_licence_pic_url,
              nm_drvr_licence_pic_thumb_url,
              nm_drvr_licence_pic_path_id,
              nm_drvr_licence_pic_path
            }
          }
          result.push(params)
          return result
        }, [])
      }
    }
  },
  methods: {
    updatePolicyFile(data) {
      this.formData.id_type_pic = data
      this.formData.id_type_pic_path_id = data.id
      this.formData.id_type_pic_path = data.name
    },
    // 更新記名司機文件
    updateDriversFile(data) {
      const { index, name, id, url, idKey, nameKey } = data
      this.$set(this.driversFileList[index], idKey, id)
      this.$set(this.driversFileList[index], nameKey, name)
      if(idKey === 'nm_drvr_id_type_pic_path_id') {
        this.$set(this.driversFileList[index], 'nm_drvr_id_type_pic_url', url)
      }
      else {
        this.$set(this.driversFileList[index], 'nm_drvr_licence_pic_url', url)
      }
      // if(!this.formData.nm_drvr_list[index]) {
      //   const temp = {
      //     nm_drvr_lst_nm: '',
      //     nm_drvr_fst_nm: '',
      //     nm_drvr_id_type_pic_url: '',
      //     nm_drvr_id_type_pic_thumb_url: '',
      //     nm_drvr_id_type_pic_path_id: '',
      //     nm_drvr_id_type_pic_path: '',
      //     nm_drvr_licence_pic_url: '',
      //     nm_drvr_licence_pic_thumb_url: '',
      //     nm_drvr_licence_pic_path_id: '',
      //     nm_drvr_licence_pic_path: ''
      //   }
      //   for(let i = 0; i <= index; i++) {
      //     if(!this.formData.nm_drvr_list[i]) {
      //       this.$set(this.formData.nm_drvr_list, i, {
      //         ...temp
      //       } )
      //     }
      //   }
      // }
      // this.formData.nm_drvr_list[index][idKey] = id
      // this.formData.nm_drvr_list[index][nameKey] = name
      // if(idKey === 'nm_drvr_id_type_pic_path_id') {
      //   this.formData.nm_drvr_list[index].nm_drvr_id_type_pic_url = url
      // } else {
      //   this.formData.nm_drvr_list[index].nm_drvr_licence_pic_url = url
      // }
    },
    async submitForm() {
      const productForm = {
        12: 'housemaid-document-form',
        14: 'travel-document-form',
        13: 'working-document-form',
        16: 'student-document-form',
        15: 'decoration-document-form',
        17: 'homefire-document-form',
        18: 'personal-document-form',
        20: 'homefire-document-form',
      }
      // 其他產品
      if(this.productId != 11) {
        return this.$refs[productForm[this.productId]].submitForm()
      }
      // 校驗
      let params = await this.validateForm()
      if(params) {
        params = JSON.parse(JSON.stringify(this.formData))
        // delete params.nm_drvr_list
        params.nm_drvr_list = this.driversFileList.filter(item => item.open || !('open' in item))
      }

      // let params = JSON.parse(JSON.stringify(this.formData))
      // delete params.nm_drvr_list
      return params
    },
    async validateForm() {
      let result = false
      await this.$refs['form'].validate((valid, rules) => {
        if(valid) {
          result = true
        }
        else {
          this.scrollToValidDom(rules)
        }
      })
      return result
    },
    handlerDeleteFile(otherData) {
      const {
        target,
        type,
        index = '',
        idKey,
        nameKey,
        urlKey,
        clientNameKey } = otherData
      if(index === '') {
        this.formData[target] = null
        this.$set(this.formData, idKey, '')
        this.$set(this.formData, nameKey, '')
      }
      else if(['nm_drvr_licence_pic','nm_drvr_id_type_pic'].includes(type)) {
        this.$set(this.driversFileList[index], idKey, '')
        this.$set(this.driversFileList[index], nameKey, '')
        this.$set(this.driversFileList[index], urlKey, '')
        this.$set(this.driversFileList[index], clientNameKey, '')
      }
      else {
        this.formData[target].splice(index, 1)
      }

      if(target == 'id_type_pic') {
        this.$emit('delete-card-file')
      }
    },
    handlerUploadSuccess({ data, result, otherData },copy_ncd=false) {
      const {
        target,
        type,
        index = '',
        idKey,
        nameKey,
        urlKey,
        clientNameKey } = otherData
      if(type === 'other_file') {
        if(!this.formData[target]) {
          this.formData[target] = []
        }
        this.formData[target].push(data)
      }
      else if(index === ''||target == 'br_pic') {
        this.$set(this.formData, target, data)
        this.$set(this.formData, idKey, data.id)
        this.$set(this.formData, nameKey, data.path)
        this.$refs['form'].clearValidate([idKey])
      }
      else if(['nm_drvr_licence_pic','nm_drvr_id_type_pic'].includes(type)) {
        this.$set(this.driversFileList[index], idKey, data.id)
        this.$set(this.driversFileList[index], nameKey, data.path)
        this.$set(this.driversFileList[index], urlKey, data.url)
        this.$set(this.driversFileList[index], clientNameKey, data.client_name)
      }
      else {
        this.$set(this.formData[target], index, data)
      }
      if(target=='renewal_letter_insurer'&&copy_ncd&&this.editTypes==3){
        this.$set(this.formData, 'ncd_proof', data)
        this.$set(this.formData, 'ncd_proof_path_id', data.id)
        this.$set(this.formData, 'ncd_proof_path', data.path)
      }
      if(target == 'id_type_pic') {
        this.$emit('upload-file', {
          ...data
        })
      }
    },
    getCardFileData() {
      if(!this.formData.id_type_pic) return {}
      return JSON.parse(JSON.stringify(this.formData.id_type_pic))
    },
    handler() {
      return {
        handlerBackFillData: data => {
          const {
            id_type_pic,
            licence_pic,
            ncd_proof,
            address_pic,
            rgtn_pic,
            rgtn_with_owner_pic,
            other_file,
            br_pic
          } = data
          if (id_type_pic) {
            this.formData = Object.assign(
              this.formData,
              {
                id_type_pic_path_id: id_type_pic.id,
                id_type_pic_path: id_type_pic.path
              }
            )
          }
          if (ncd_proof) {
            this.formData = Object.assign(
              this.formData,
              {
                ncd_proof_path_id: ncd_proof.id,
                ncd_proof_path: ncd_proof.path
              }
            )
          }
          if (rgtn_pic) {
            this.formData = Object.assign(
              this.formData,
              {
                rgtn_pic_path_id: rgtn_pic.id,
                rgtn_pic_path: rgtn_pic.path
              }
            )
          }
          if (rgtn_with_owner_pic) {
            this.formData = Object.assign(
              this.formData,
              {
                rgtn_with_owner_pic_path_id: rgtn_with_owner_pic.id,
                rgtn_with_owner_pic_path: rgtn_with_owner_pic.path
              }
            )
          }
          if(br_pic) {
            this.formData = Object.assign(
              this.formData,
              {
                br_pic_path_id: br_pic.id,
                br_pic_path: br_pic.path
              }
            )
          }
          let {renew_order_id} = this.form||{}
          if(this.editTypes==3&&renew_order_id<=0){
            this.formData.ncd_proof_path_id=''
            this.formData.ncd_proof_path=''
            this.formData.ncd_proof={}
          }
        },
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.document-form {
    position: relative;
}
</style>
